import React, { useEffect } from 'react';

import { toastPool } from '../../toasts/models/toast-pool';
import { Toast } from '../../toasts/models/toast';
import { SingleSelectDropdown } from '../../../components/select-dropdown';

import styles from './role-select.module.scss';
interface Props {
  onChange: (value: string) => void;
  value?: string;
  errorMessage?: string | null;
  hideLabel?: boolean;
}

interface Option {
  label: string;
  value: string;
}

const createOption = (value: string) => ({
  label: value,
  value: value,
});

export const RoleSelect: React.FC<Props> = ({ onChange, value, errorMessage, hideLabel }) => {
  const [options, setOptions] = React.useState<Option[]>([]);

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const response = await fetch('/data/film_crew_roles.csv', {
          headers: {
            'Cache-Control': 'public, max-age=15778476, immutable',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const csvText = await response.text();

        const roles = csvText
          .split('\n')
          .slice(1)
          .filter((role) => role.trim())
          .map((role) => createOption(role.trim()));

        // If we have a value that's not in the roles list, add it as a custom option
        if (value && !roles.some((role) => role.value === value)) {
          roles.push(createOption(value));
        }

        setOptions(roles);
      } catch (error) {
        console.error('Error loading roles:', error);
        toastPool.insert(new Toast('Failed to load roles list. Please try again later.', 'error'));

        if (value) {
          setOptions([{ label: value, value }]);
        }
      }
    };

    loadRoles();
  }, [value]);

  const handleChange = (newValue?: string) => {
    if (newValue) {
      onChange(newValue);
    }
  };

  const handleCreate = (inputValue: string) => {
    const newOption = createOption(inputValue);
    setOptions([...options, newOption]);
    onChange(newOption.value);
  };

  return (
    <div className={styles['container']}>
      {!hideLabel && <label>Role</label>}

      <SingleSelectDropdown
        title="Role"
        value={value}
        options={options}
        onValueChange={handleChange}
        onCreate={handleCreate}
        placeholder="Choose from the list or use your own"
      />
    </div>
  );
};
